import { render, staticRenderFns } from "./passwordReset.vue?vue&type=template&id=1d2a8784&scoped=true&"
import script from "./passwordReset.vue?vue&type=script&lang=js&"
export * from "./passwordReset.vue?vue&type=script&lang=js&"
import style0 from "./passwordReset.vue?vue&type=style&index=0&id=1d2a8784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2a8784",
  null
  
)

export default component.exports